import { reduxForm } from 'redux-form/immutable.js';
import { compose, withProps, setDisplayName } from 'react-recompose';
import { postOrganization } from '~/state/ducks/organizations/operations.js';

import PortalForm from './PortalForm.js';


const initialValues = {
    portal: true,
};

export default compose(
    setDisplayName('OrganizationCreateContainer'),
    reduxForm({
        form: 'portal-create',
        onSubmit: postOrganization,
        initialValues,
    }),
    withProps({
        header: 'Create',
        isCreate: true,
    }),
)(PortalForm);
